<p-toast position="top-right" [baseZIndex]="9999">
  <ng-template #message let-msg>
    @switch (msg.severity) {
      @case ('success') { <i class="bi bi-check-circle p-toast-message-icon" aria-hidden="true"></i> }
      @case ('info') { <i class="bi bi-info-circle p-toast-message-icon" aria-hidden="true"></i> }
      @case ('warn') { <i class="bi bi-exclamation-triangle p-toast-message-icon" aria-hidden="true"></i> }
      @default { <i class="bi bi-x-circle p-toast-message-icon" aria-hidden="true"></i> }
    }
    <div class="p-toast-message-text">
      <span class="p-toast-summary">{{ msg.summary }}</span>
      <div class="p-toast-detail" [innerHTML]="msg.detail"></div>
    </div>
  </ng-template>
</p-toast>
